import type { GaApp } from '~/modules/app'

import { MainService } from './main.service'

export const services = (gaApp: GaApp) => ({
  main: new MainService(gaApp),
})
